import React from 'react'
import Link from 'gatsby-link'

import { rhythm, scale } from '../utils/typography'
import profilePic from '../components/profile-pic.svg'

class Template extends React.Component {
  render() {
    const { location, children } = this.props

    let rootPath = `/`
    if (typeof __PREFIX_PATHS__ !== `undefined` && __PREFIX_PATHS__) {
      rootPath = __PATH_PREFIX__ + `/`
    }

    return (
      <div
        style={{
          marginLeft: 'auto',
          marginRight: 'auto',
          maxWidth: rhythm(24),
          padding: `${rhythm(1.5)} ${rhythm(3 / 4)}`,
        }}
      >
             <img
              src={profilePic}
              alt={`Jordan Wade`}
              style={{
                marginRight: rhythm(1 / 2),
                marginBottom: 0,
                width: rhythm(2),
                height: rhythm(2),
              }}
            />
      </div>
    )
  }
}

export default Template



// WEBPACK FOOTER //
// ./src/layouts/index.js